export default "__VITE_ASSET__DfjICLrm__"